module.exports = __webpack_public_path__ + "img/perform.91f7844c.svg";